import { SearchEngines } from 'features/aiWriter/AiWriterSidebar/steps/seoAnalysis/searchEngines';

export const searchEnginesOptions = Object.values(SearchEngines);
